export const SUPPLIER_PROFILE_SETTING_ACTIONS = {
  CREATE_SUPPLIER_PROFILE: 'createSupplierProfile',
  DUPLICATE_SUPPLIER_PROFILE: 'duplicateSupplierProfile',
  ASSOCIATE_SUPPLIER_PROFILE_STORES: 'associateSupplierProfileStore',
};
